$(document).ready(function() {
  const inputField = $('#product-form-installment input[name="id"]');
  const recommendationParagraph = $('#WeightRecommendation');

  function updateVariantIdAndRecommendation() {
    const variantId = inputField.val();

    recommendationParagraph.text(window.recommendationMapping[variantId] || '');
    if(variantId == 43340172361952 || variantId == 57165650526533) {
      $("#extrainfobox").css("display", "block");
    }
    else {
      $("#extrainfobox").css("display", "none");
    }
  }

  // Event listener til inputfeltet med navnet "id" inden for formularen
  inputField.on('change', updateVariantIdAndRecommendation);

  // Kald funktionen første gang for at vise det aktuelle variantID og anbefaling
  updateVariantIdAndRecommendation();
});